import { render } from "./Gateways.vue?vue&type=template&id=61116a05&scoped=true&ts=true"
import script from "./Gateways.vue?vue&type=script&lang=ts"
export * from "./Gateways.vue?vue&type=script&lang=ts"

import "./Gateways.vue?vue&type=style&index=0&id=61116a05&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61116a05"]])

export default __exports__